import { IRUMStrategy, IUserInfo } from '@nab/x-types';
import { RUMEventData, IRUMUserDataProvider } from '@nab/x-spa-react';
import { AppDRUMStrategy } from '@nab/nab-x-sdk-browser';
import { AppConfig } from '../auth/AppConfig';

export class LocalRumMonitoring implements IRUMStrategy {
    private userInfo: Partial<IUserInfo>;
    private shellId = undefined;

    public emitEvent(eventData: RUMEventData, userDataProvider?: IRUMUserDataProvider): void {
        console.log('rum.emitEvent', eventData, userDataProvider?.getDataForError?.());
    }

    setUser(userInfo: Partial<IUserInfo>): void {
        this.userInfo = userInfo;
    }

    setShellId(shellId: string): void {
        this.shellId = shellId;
    }
}

export function makeRumStrategy(environment: string, config: AppConfig): IRUMStrategy {
    if (environment === 'local') {
        return new LocalRumMonitoring();
    }

    return new AppDRUMStrategy({
        libraryUrl: 'https://x.nab.com.au/static-shared/nab/js/appd/adrum-23.3.0.4265.js',
        configValue: {
            appKey: config.appDynamicsKey,
            adrumExtUrlHttp: 'http://x.nab.com.au/static-shared/nab/js/appd',
            adrumExtUrlHttps: 'https://x.nab.com.au/static-shared/nab/js/appd',
            beaconUrlHttp: 'http://syd-col.eum-appdynamics.com',
            beaconUrlHttps: 'https://syd-col.eum-appdynamics.com',
            xd: {
                // x.nab.com.au only allows framing from production origins, so the
                // cross-domain correlation iframe is blocked by CSP outside prod.
                enable: environment === 'prod'
            },
            spa: {
                spa2: true
            }
        }
    });
}
